import { AppState } from 'Features/App/store';
import { dcpcApi } from './dcpcApi';
import { DatasourceTypeType } from './v2';

export const DATASOURCE_TYPES_TAG = 'DATASOURCE_TYPES_TAG';

const apiTS = dcpcApi.injectEndpoints({
  endpoints: (builder) => ({
    getDatasourceTypes: builder.query<DatasourceTypeType[], void>({
      query: () => 'datasource-types',
    }),
  }),
});

dcpcApi.enhanceEndpoints({
  addTagTypes: [DATASOURCE_TYPES_TAG],
  endpoints: {
    getDatasourceTypes: {
      providesTags: [DATASOURCE_TYPES_TAG],
    },
  },
});

export const {
  useGetDatasourceTypesQuery,
} = apiTS;

const rtkDatasourceTypesSelect = (state: AppState) => apiTS.endpoints.getDatasourceTypes.select()(state);
export const rtkDatasourceTypesSelector = (state: AppState): DatasourceTypeType[] => rtkDatasourceTypesSelect(state).data || [];
